<template>
  <span>
    <v-tooltip :disabled="!signer.firmado" top>
      <template v-slot:activator="{ on: tooltip }">
        <div v-on="tooltip" class="d-inline-block">
          <v-icon
            v-on="{...tooltip}"
            :small="small"
            :color="color"
            :disabled="signer.firmado"
            @click="click"
            >{{ icon.pencil }}</v-icon
          >
        </div>
      </template>
      <span>El firmante no puede ser modificado debido a que ya realizó la firma del documento</span>
    </v-tooltip>
  </span>
</template>

<script>
import { mdiPencilOutline } from '@mdi/js'
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'

export default {
  name: 'signerUpdate',
  props: {
    signer: { type: Object, required: true },
    small: { type: Boolean, default: false },
    color: { type: String, default: 'grey darken-1' }
  },
  data(){
    return {
      icon: {
        pencil: mdiPencilOutline
      }
    }
  },
  computed: {
    ...signersStoreData
  },
  methods: {
    ...signersStoreActions,
    click() {
      this.$emit('click', this.signer)
    }
  }
}
</script>
